
import Vue, { PropType } from 'vue';
import Api from '@/core/api';
import Icon from '@/common/icon/Icon.vue';
import { PlayerState } from '@/core/player-state';
import { isFunction, get } from 'lodash';
import { Unsubscriber } from '@/core/event-bus';

interface BigPlayButtonConfig {
    seekToLiveOnPlay: boolean,
}

export default Vue.extend({
    name: 'BigPlayButton',

    components: {
        Icon
    },

    props: {
        api: {
            type: Object as PropType<Api>,
            required: true,
        },
        config: {
            type: Object as PropType<BigPlayButtonConfig>,
            default: () => ({} as BigPlayButtonConfig)
        },
        labels: {
            type: Object as PropType<Record<string, unknown>>,
            default: () => ({})
        }
    },

    data() {
        return {
            isPlaying: false,
            videoDurationSecs: 0,
            unsubscribers: [] as Unsubscriber[]
        };
    },

    computed: {
        seekToLiveOnPlay(): boolean {
            return this.config.seekToLiveOnPlay;
        }
    },

    mounted() {
        const { unsubscriber, state } = this.api.onStateChange(this.onStateChange);
        this.onStateChange(state);
        this.unsubscribers.push(unsubscriber);
    },

    beforeDestroy() {
        for (const unsubscriber of this.unsubscribers) {
            if (isFunction(unsubscriber)) {
                unsubscriber();
            }
        }
    },

    methods: {
        onStateChange(state: Partial<PlayerState>) {
            this.isPlaying = get(state, 'isPlaying', this.isPlaying);
            this.videoDurationSecs = get(state, 'videoDurationSecs', this.videoDurationSecs);
        },

        click() {
            if (this.isPlaying) {
                console.debug('[BigPlayButton] pause');
                this.api.pause();
            } else {
                if (this.seekToLiveOnPlay && this.videoDurationSecs > 1) {
                    // for live streams, to prevent playing some old segments on resume, we seek to the current live position
                    console.log('[PlayStopToggle] seeking to live position');
                    this.api.seek(this.videoDurationSecs - 1);
                }
                this.api.play();
            }
        }
    }
});
